import { Button, Col, Form, Input, Modal, Row, Select } from "antd";
import userApi from "api/user";
import { cabinetData } from "constants/";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ModalCreated({
  openModal,
  setOpenModal,
  openNotificationWithIcon,
  setDataShop,
  dataShop,
  getStore,
}) {
  const [form] = Form.useForm();
  const cabinet = Form.useWatch('cabinet', form);

  const { t } = useTranslation()

  const onSubmit = async (values) => {
    try {
      if (!dataShop) {
        const res = await userApi.createShopManager(values);
        if (res?.success) {
          onCancel();
          openNotificationWithIcon("success", t('notification'), t('addShopSuccess'));
          getStore();
        }
      } else {
        const res = await userApi.updateShopManager({
          ...values,
          shop_id: dataShop.shops[0].shop._id,
          user_id: dataShop._id
        });
        if (res?.success) {
          onCancel();
          openNotificationWithIcon("success", t('notification'), t("updateShopSuccess"));
          getStore();
        }
      }
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    }
  };

  const onCancel = () => {
    setOpenModal(false);
    setDataShop(null);
    form.resetFields();
  };

  useEffect(() => {
    if (dataShop) {
      form.setFieldsValue({
        user_name: dataShop.user_name,
        shop_code: dataShop.shops[0].shop.shop_code,
        shop_name: dataShop.name,
        cabinet: dataShop.shops[0].shop.cabinet,
        cabinet_code_1: dataShop.shops[0].shop?.cabinet_code_1,
        cabinet_code_2: dataShop.shops[0].shop?.cabinet_code_2,
      });
    }
  }, [dataShop, form]);

  return (
    <Modal
      title={!dataShop ? t('addShop') : t('updateShop')}
      centered
      open={openModal}
      footer={null}
      onCancel={onCancel}
      width={768}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="shop_name"
          label={t('shopName')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="shop_code"
          label={t('shopCode')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="user_name"
          label={t('userName')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        {
          !dataShop &&
          <>
            <Form.Item
              name="password"
              label={t('password')}

              required
              rules={[
                {
                  required: true,
                },
                {
                  min: 4,
                  message: t('minLength', { value: 4 }),
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirm"
              label={t('confirmPassword')}

              required
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t('notMatchPassword')));
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </>
        }
        <Form.Item
          name="cabinet"
          label={t('numCabinet')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select options={cabinetData} allowClear />
        </Form.Item>
        {
          cabinet > 0 &&
          <Form.Item
            name="cabinet_code_1"
            label={t('cabinetCode') + ' 1'}
            required
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
        }
        {
          cabinet > 1 &&
          <Form.Item
            name="cabinet_code_2"
            label={t('cabinetCode') + ' 2'}
            required
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
        }
        <Row gutter={16}>
          <Col span={4} offset={8}>
            <Form.Item>
              <Button style={{ width: "100%" }} htmlType="submit">
                Ok
              </Button>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Button style={{ width: "100%" }} onClick={onCancel}>
              {t('cancel')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
